<template>
	<div class="life-chart">
		<CHeader :isGradient="true" bg="linear-gradient(to bottom, #ef9916, #ef991600)">基本命盘</CHeader>
		<div class="content">
			<PatternBox>
				<div class="base-info">
					<Caption>基本信息</Caption>
					<div class="table-wrapper">
						<table class="diy-table" width="100%">
							<tr>
								<td class="td-key">姓名</td>
								<td class="td-value">{{ tabData[0].name }}</td>
								<td class="td-key">性别</td>
								<td class="td-value">
									{{ tabData[0].sex == 1 ? "男" : "女" }}
								</td>
								<td class="td-key">属相</td>
								<td class="td-value">{{ tabData[0].animal }}</td>
							</tr>
							<tr>
								<td class="td-key">地点</td>
								<td class="td-value" colspan="5">
									{{ tabData[0].address }}
								</td>
							</tr>
							<tr>
								<td class="td-key">日期</td>
								<td class="td-value" colspan="5">
									<p>阴历：{{ tabData[0].lunar }}</p>
									<p>阳历：{{ tabData[0].gregorian }}</p>
								</td>
							</tr>
							<tr>
								<td class="td-key">真太<br />阳时</td>
								<td class="td-value" colspan="5">
									<p>阴历：{{ tabData[0].real_lunar }}</p>
									<p>阳历：{{ tabData[0].real_gregorian }}</p>
								</td>
							</tr>
							<tr>
								<td class="td-key">节气</td>
								<td class="td-value" colspan="5">
									<p>上节：{{ tabData[0].term_upper }}</p>
									<p>下节：{{ tabData[0].terms_lower }}</p>
								</td>
							</tr>
						</table>
					</div>
					<div class="table-wrapper">
						<table class="diy-table" width="100%">
							<tr>
								<td class="td-key" width="30%">
									<p>星座</p>
									<!-- <p>二十八星宿</p> -->
								</td>
								<td class="td-value">
									<p>{{ tabData[0].constellation }}座</p>
									<!-- <p>{{ tabData[0].stars }}</p> -->
								</td>
							</tr>
							<tr>
								<td class="td-key">空亡(日年)</td>
								<td class="td-value">{{ tabData[0].kongwang }}</td>
							</tr>
							<tr>
								<td class="td-key">命宫</td>
								<td class="td-value">{{ tabData[0].minggong }}</td>
							</tr>
							<tr>
								<td class="td-key">胎元</td>
								<td class="td-value">{{ tabData[0].taiyuan }}</td>
							</tr>
							<tr>
								<td class="td-key">胎息</td>
								<td class="td-value">{{ tabData[0].taixi }}</td>
							</tr>
						</table>
					</div>
				</div>
			</PatternBox>
			<PatternBox>
				<div class="natal-chart">
					<div class="table-wrapper">
						<table class="diy-table" width="100%">
							<thead>
								<tr>
									<td></td>
									<td class="td-key">年柱</td>
									<td class="td-key">月柱</td>
									<td class="td-key">日柱</td>
									<td class="td-key">时柱</td>
								</tr>
							</thead>
							<tr>
								<td class="td-key" width="15%">主星</td>
								<td class="td-value">{{ tabData[2].shishen_year }}</td>
								<td class="td-value">{{ tabData[2].shishen_month }}</td>
								<td class="td-value">
									{{ tabData[2].sex == "1" ? "日主" : "日主" }}
								</td>
								<td class="td-value">{{ tabData[2].shishen_shi }}</td>
							</tr>
							<tr>
								<td class="td-key">天干</td>
								<td class="td-value color-orange">
									{{ tabData[2].gan_year }}
								</td>
								<td class="td-value color-orange">
									{{ tabData[2].gan_month }}
								</td>
								<td class="td-value color-red">{{ tabData[2].gan_day }}</td>
								<td class="td-value color-orange">
									{{ tabData[2].gan_shi }}
								</td>
							</tr>
							<tr>
								<td class="td-key">地支</td>
								<td class="td-value color-orange">
									{{ tabData[2].zhi_year }}
								</td>
								<td class="td-value color-orange">
									{{ tabData[2].zhi_month }}
								</td>
								<td class="td-value color-red">{{ tabData[2].zhi_day }}</td>
								<td class="td-value color-orange">
									{{ tabData[2].zhi_shi }}
								</td>
							</tr>
							<tr>
								<td class="td-key" rowspan="4">藏干</td>
							</tr>
							<tr>
								<td class="td-value">{{ tabData[2].cangan_year[0] }}</td>
								<td class="td-value">{{ tabData[2].cangan_month[0] }}</td>
								<td class="td-value">{{ tabData[2].cangan_day[0] }}</td>
								<td class="td-value">{{ tabData[2].cangan_shi[0] }}</td>
							</tr>
							<tr>
								<td class="td-value">{{ tabData[2].cangan_year[1] }}</td>
								<td class="td-value">{{ tabData[2].cangan_month[1] }}</td>
								<td class="td-value">{{ tabData[2].cangan_day[1] }}</td>
								<td class="td-value">{{ tabData[2].cangan_shi[1] }}</td>
							</tr>
							<tr>
								<td class="td-value">{{ tabData[2].cangan_year[2] }}</td>
								<td class="td-value">{{ tabData[2].cangan_month[2] }}</td>
								<td class="td-value">{{ tabData[2].cangan_day[2] }}</td>
								<td class="td-value">{{ tabData[2].cangan_shi[2] }}</td>
							</tr>
							<tr>
								<td class="td-key" rowspan="4">副星</td>
							</tr>
							<tr>
								<td class="td-value">{{ tabData[2].zhishen_year[0] }}</td>
								<td class="td-value">{{ tabData[2].zhishen_month[0] }}</td>
								<td class="td-value">{{ tabData[2].zhishen_day[0] }}</td>
								<td class="td-value">{{ tabData[2].zhishen_shi[0] }}</td>
							</tr>
							<tr>
								<td class="td-value">{{ tabData[2].zhishen_year[1] }}</td>
								<td class="td-value">{{ tabData[2].zhishen_month[1] }}</td>
								<td class="td-value">{{ tabData[2].zhishen_day[1] }}</td>
								<td class="td-value">{{ tabData[2].zhishen_shi[1] }}</td>
							</tr>
							<tr>
								<td class="td-value">{{ tabData[2].zhishen_year[2] }}</td>
								<td class="td-value">{{ tabData[2].zhishen_month[2] }}</td>
								<td class="td-value">{{ tabData[2].zhishen_day[2] }}</td>
								<td class="td-value">{{ tabData[2].zhishen_shi[2] }}</td>
							</tr>
							<tr>
								<td class="td-key">纳音</td>
								<td class="td-value">{{ tabData[2].nayin_year }}</td>
								<td class="td-value">{{ tabData[2].nayin_month }}</td>
								<td class="td-value">{{ tabData[2].nayin_day }}</td>
								<td class="td-value">{{ tabData[2].nayin_shi }}</td>
							</tr>
							<tr>
								<td class="td-key">四支<br />旺衰</td>
								<td class="td-value">{{ tabData[2].cs_y }}</td>
								<td class="td-value">{{ tabData[2].cs_m }}</td>
								<td class="td-value">{{ tabData[2].cs_d }}</td>
								<td class="td-value">{{ tabData[2].cs_s }}</td>
							</tr>
							<tr>
								<td class="td-key">神煞</td>
								<!-- <td class="td-value">{{ tabData[2].shensha_y }}</td>
                    <td class="td-value">{{ tabData[2].shensha_m }}</td>
                    <td class="td-value">{{ tabData[2].shensha_d }}</td>
                    <td class="td-value">{{ tabData[2].shensha_s }}</td> -->
								<td class="td-value">
									<span v-for="(item, i) of tabData[2].shensha_y" :key="i">{{ item }}</span>
								</td>
								<td class="td-value">
									<span v-for="(item, i) of tabData[2].shensha_m" :key="i">{{ item }}</span>
								</td>
								<td class="td-value">
									<span v-for="(item, i) of tabData[2].shensha_d" :key="i">{{ item }}</span>
								</td>
								<td class="td-value">
									<span v-for="(item, i) of tabData[2].shensha_s" :key="i">{{ item }}</span>
								</td>
							</tr>
						</table>
					</div>
				</div>
			</PatternBox>
			<PatternBox>
				<div class="five">
					<Caption>五行分数</Caption>
					<p class="score">共{{ tabData[1].sqrdefen }}分</p>
					<div class="progress-wrapper">
						<div class="progress-item" v-for="(item, i) of tabData[1].wxdefen" :key="i">
							<p class="progress-item-label">{{ item[0] }}</p>
							<div class="progress-div">
								<Progress
									:color="item[0] == '水'? '#44d178': item[0] == '火'? '#ff6857': item[0] == '土'? '#cc9a4d': item[0] == '金'? '#ffc247': '#646865'"
									:value="item[1]"></Progress>
							</div>
							<p class="progress-item-remark">
								<span>({{ item[2] }}{{ item[3] }} </span>
								<span>{{ item[4] }}{{ item[5] }})</span>
							</p>
						</div>
					</div>
				</div>
			</PatternBox>
			<PatternBox>
				<div class="fleeting-time">
					<Caption>大运</Caption>
					<div class="table-wrapper">
						<table class="diy-table" width="100%">
							<thead>
								<tr>
									<td colspan="9" style="border-right: none">
										(出生{{tabData[3].dayun_qiyun}}后开始行大运，每交大运<span
											class="color-red">{{tabData[3].dayun_jiaoyun}}</span>起运)
									</td>
								</tr>
							</thead>
							<tr>
								<td class="td-key">岁</td>
								<td class="td-value" v-for="(i, n) in tabData[3].dayun" :key="n">
									<p>{{ i[0] }}</p>
									<p>|</p>
									<p>{{ i[1] }}</p>
								</td>
							</tr>
							<tr>
								<td class="td-key">起运</td>
								<td class="td-value" v-for="(i, n) in tabData[3].dayun" :key="n">
									{{ i[2] }}
								</td>
							</tr>
							<tr>
								<td class="td-key">干神</td>
								<td class="td-value color-orange" v-for="(i, n) in tabData[3].dayun" :key="n">
									{{ i[3] }}
								</td>
							</tr>
							<tr>
								<td class="td-key">天干</td>
								<td class="td-value color-orange" v-for="(i, n) in tabData[3].dayun" :key="n">
									{{ i[4] }}
								</td>
							</tr>
							<tr>
								<td class="td-key">地支</td>
								<td class="td-value" v-for="(i, n) in tabData[3].dayun" :key="n">
									{{ i[5] }}
								</td>
							</tr>
							<tr>
								<td class="td-key">支神</td>
								<td class="td-value" v-for="(i, n) in tabData[3].dayun" :key="n">
									<p v-for="(item, number) of i[6]" :key="number">
										{{ item }}
									</p>
								</td>
							</tr>
							<tr>
								<td class="td-key">旺衰</td>
								<td class="td-value color-orange" v-for="(i, n) in tabData[3].dayun" :key="n">
									{{ i[7] }}
								</td>
							</tr>
						</table>
					</div>
				</div>
			</PatternBox>

			<PatternBox>
				<div class="conclusion">
					<Caption>基本凭判</Caption>
					<div class="paragraph">
						<p class="title color-orange">命宫趋向</p>
						<p class="desc">
							<span v-for="(item, i) of tabData[4].minggong" :key="i">{{item}}</span>
						</p>
					</div>
					<div class="paragraph">
						<p class="title color-orange">袁天罡称骨</p>
						<p class="desc">
							{{ tabData[4].ytzl }}
						</p>
					</div>
					<div class="paragraph">
						<p class="title color-orange">意解</p>
						<p class="desc" v-for="(item, i) of tabData[4].ytsm" :key="i">
							{{ item }}
						</p>
					</div>
					<div class="paragraph">
						<p class="title color-orange">基本凭判</p>
						<div v-for="(item, i) of tabData[4].dsdy" :key="i">
							<p class="desc" v-for="(sitem, si) of item" :key="si">{{sitem}}</p>
						</div>
					</div>
				</div>
			</PatternBox>
		</div>
	</div>
</template>

<script>
	import "../assets/css/flexbox.css";
	import "../assets/css/common.css";
	import CHeader from "../components/Header.vue";
	import PatternBox from "../components/PatternBox.vue";
	import Caption from "../components/Caption.vue";
	import Progress from "../components/Progress.vue";
	import {
		callNative
	} from "native-jsbridge";
	import common from "../assets/js/common";

	export default {
		components: {
			CHeader,
			PatternBox,
			Caption,
			Progress,
		},
		props: ['phone','name', 'birthday', 'sex','prov','city','area','type'],
		data() {
			return {
				active: 0,
				tabData: [],
			};
		},
		created() {
			this.loadData();
		},
		methods: {
			loadData() {
				const params = {
					phone: this.phone,
					name: this.name,
					birthday: this.birthday,
					sex: this.sex,
					prov: this.prov,
					city: this.city,
					area: this.area,
					type: this.type
				}
				this.axios.post("/api/jbsm", params).then((data) => {
					if (data.code == 0) {
						this.tabData = data.data.jbsm_data;
					}
				});
			},
			toPage(url) {
				callNative({
					method: "openPage",
					data: {
						url: url,
						visibleActionBar: false,
						transluentStatusBar: true,
					},
				});
			},
			toLocalPage(url) {
				if (common.isAndroid()) {
					callNative({
						method: "openPage",
						data: {
							url: common.pageDomain + url,
							visibleActionBar: false,
							transluentStatusBar: true,
						},
					});
				} else {
					this.$router.push(url);
				}
			},
		},
	};
</script>

<style lang="less" scoped>
	.life-chart {
		background-image: url("../assets/imgs/home/background.jpg");
		display: flex;
		flex-direction: column;
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		margin-bottom: 1rem;

		.content {
			width: 100%;
			overflow-y: scroll;

			/deep/ .van-tabs {
				padding: 0 0.25rem 0.25rem;

				.van-tabs__wrap {
					margin-bottom: 0.25rem;

					.van-tab {
						font-size: 0.4rem;
					}

					.van-tab--active {
						color: #ffffff;
						font-size: 0.5rem;
					}
				}
			}

			// 基本
			.base-info {
				padding-top: 0.2rem;

				.diy-table {
					.td-value {
						text-align: left;
					}
				}
			}

			.five {
				.score {
					position: relative;
					font-size: 0.32rem;
					font-weight: 400;
					line-height: 0.45rem;
					color: #432f12;
					text-align: center;
					top: -0.3rem;
					margin-bottom: 0.37rem;
				}

				.progress-wrapper {
					width: 100%;
					min-height: 4.27rem;
					background: rgba(250, 171, 50, 0.08);
					border: 1px solid rgba(250, 171, 50, 0.5);
					opacity: 1;
					border-radius: 0.15rem;
					padding: 0.61rem 0.3rem 0.61rem 0.49rem;

					.progress-item {
						font-size: 0.37rem;
						display: flex;
						align-items: center;
						width: 100%;

						&+.progress-item {
							margin-top: 0.2rem;
						}

						.progress-item-label {
							font-weight: bold;
							margin-right: 0.33rem;
						}

						.progress-div {
							position: relative;
							top: 2px;
							width: 3.6rem;
							// padding: 0.038rem 0.04rem 0.039rem 0.1rem;
							border-radius: 1rem;
							display: flex;
							align-items: center;
							margin-right: 0.8rem;

							.progress-item-value {
								position: absolute;
								right: -0.4rem;
							}

							/deep/.van-progress__pivot {
								/* position: absolute;
              top: 50%;
              transform: translateY(-50%); */
								line-height: 0.9;
							}
						}

						.progress-item-remark {
							color: #827461;
							margin-left: 0.2rem;
						}

						.green {
							color: #44d178;
							border: 1px solid #44d178;

							/deep/.van-progress__pivot {
								color: #44d178;
							}
						}

						.red {
							color: #ff6857;
							border: 1px solid #ff6857;
						}

						.brown {
							color: #cc9a4d;
							border: 1px solid #cc9a4d;
						}

						.gold {
							color: #ffc247;
							border: 1px solid #ffc247;
						}

						.gray {
							color: #646865;
							border: 1px solid #646865;
						}
					}
				}

				.diy-table {
					.td-value {
						text-align: left;
					}
				}
			}

			// 命盘
			.natal-chart {
				margin-top: 1rem;
			}

			// 流年
			.fleeting-time {
				margin-top: 0.5rem;

				.table-wrapper {
					.diy-table {
						.td-value {
							font-size: 12px;
							padding-left: 0rem;
							padding-right: 0rem;
						}

						&.fs37 {
							.td-value {
								font-size: 0.37rem;
							}
						}
					}
				}
			}

			// 断语
			.conclusion {
				margin-top: 0.5rem;
			}

			.table-wrapper {
				border: 1px solid #faab32;
				border-radius: 0.15rem;

				&+.table-wrapper {
					margin-top: 0.61rem;
				}
			}

			.diy-table {
				font-size: 0.37rem;

				thead {
					tr {
						background: #fddcac;
					}
				}

				tr {
					border-bottom: 1px solid #faab32;

					&:last-child {
						border-bottom: none;
					}

					td {
						padding: 0.24rem;
						color: #827461;
						border-right: 1px solid #faab32;
						text-align: center;

						&:last-child {
							border-right: none;
						}

						&:only-child {
							border-right: 1px solid #faab32;
						}
					}

					.td-key {
						font-size: 0.37rem;
						font-weight: bold;
						color: #000000;
						background: #fcab331a;
					}

					.td-value {
						p+p {
							margin-top: 0.1rem;
						}
					}
				}
			}

			.paragraph {
				padding-bottom: 0.37rem;
				border-bottom: 1px solid #e6e6e6;

				.title {
					font-size: 0.41rem;
					font-weight: bold;
					margin-bottom: 0.2rem;
				}

				.desc {
					font-size: 0.37rem;
					font-weight: 400;
					color: #827461;
					line-height: 0.55rem;

					&+.desc {
						margin-top: 0.2rem;
					}
				}

				&+.paragraph {
					margin-top: 0.51rem;
				}
			}
		}

		.color-orange {
			color: #faab32 !important;
		}

		.color-red {
			color: #ff6857 !important;
		}
	}
</style>
